import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0f82aa68 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _71fd871a = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _532b2bc7 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _08f08ee8 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _5b49e138 = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _56ab3e4c = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _58d84698 = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _575b401c = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _ef06cfde = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _6668606c = () => interopDefault(import('../pages/franchise/index.vue' /* webpackChunkName: "pages/franchise/index" */))
const _1660eab0 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _7639fbd5 = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _24886738 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _4aefd29e = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _535277ba = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _40f724dd = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _6457c8e7 = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _4468d70b = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _dd72da4e = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _067cddca = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _125a2e6c = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _370a5e0c = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _7661b9da = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _3bb176b6 = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _0d40029e = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _446405ae = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _6fd13565 = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _10a99aba = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _5be90b01 = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _1018f5bd = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _7ee72f34 = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _25108ded = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _2232a5a8 = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _95ec3ca8 = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _7074f1e8 = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _0b2e441b = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _6b1771f4 = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _848c5b56 = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _6cbf4747 = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _76e4295e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions",
    component: _0f82aa68,
    name: "actions"
  }, {
    path: "/brands",
    component: _71fd871a,
    name: "brands"
  }, {
    path: "/cart",
    component: _532b2bc7,
    name: "cart"
  }, {
    path: "/catalog",
    component: _08f08ee8,
    name: "catalog"
  }, {
    path: "/collections",
    component: _5b49e138,
    name: "collections"
  }, {
    path: "/company",
    component: _56ab3e4c,
    name: "company"
  }, {
    path: "/compare",
    component: _58d84698,
    name: "compare"
  }, {
    path: "/delete-account",
    component: _575b401c,
    name: "delete-account"
  }, {
    path: "/favourites",
    component: _ef06cfde,
    name: "favourites"
  }, {
    path: "/franchise",
    component: _6668606c,
    name: "franchise"
  }, {
    path: "/help",
    component: _1660eab0,
    name: "help"
  }, {
    path: "/info",
    component: _7639fbd5,
    name: "info"
  }, {
    path: "/login",
    component: _24886738,
    name: "login"
  }, {
    path: "/logout",
    component: _4aefd29e,
    name: "logout"
  }, {
    path: "/news",
    component: _535277ba,
    name: "news"
  }, {
    path: "/order",
    component: _40f724dd,
    name: "order"
  }, {
    path: "/personal",
    component: _6457c8e7,
    name: "personal"
  }, {
    path: "/products",
    component: _4468d70b,
    name: "products"
  }, {
    path: "/stores",
    component: _dd72da4e,
    name: "stores"
  }, {
    path: "/video",
    component: _067cddca,
    name: "video"
  }, {
    path: "/company/about",
    component: _125a2e6c,
    name: "company-about"
  }, {
    path: "/company/contacts",
    component: _370a5e0c,
    name: "company-contacts"
  }, {
    path: "/company/requisites",
    component: _7661b9da,
    name: "company-requisites"
  }, {
    path: "/order/pay",
    component: _3bb176b6,
    name: "order-pay"
  }, {
    path: "/order/pay-error",
    component: _0d40029e,
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok",
    component: _446405ae,
    name: "order-pay-ok"
  }, {
    path: "/personal/bonuses",
    component: _6fd13565,
    name: "personal-bonuses"
  }, {
    path: "/personal/orders",
    component: _10a99aba,
    name: "personal-orders"
  }, {
    path: "/personal/profile",
    component: _5be90b01,
    name: "personal-profile"
  }, {
    path: "/personal/orders/:_id",
    component: _1018f5bd,
    name: "personal-orders-_id"
  }, {
    path: "/actions/:_id",
    component: _7ee72f34,
    name: "actions-_id"
  }, {
    path: "/brands/:_id",
    component: _25108ded,
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug",
    component: _2232a5a8,
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug",
    component: _95ec3ca8,
    name: "collections-_slug"
  }, {
    path: "/help/:_slug",
    component: _7074f1e8,
    name: "help-_slug"
  }, {
    path: "/info/:_slug",
    component: _0b2e441b,
    name: "info-_slug"
  }, {
    path: "/news/:_id",
    component: _6b1771f4,
    name: "news-_id"
  }, {
    path: "/products/:_id",
    component: _848c5b56,
    name: "products-_id"
  }, {
    path: "/stores/:_id",
    component: _6cbf4747,
    name: "stores-_id"
  }, {
    path: "/",
    component: _76e4295e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
